import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { AuthService } from "../../../services/auth/auth.service";

@Component({
  selector: "app-register",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    CardModule,
    RouterLink,
  ],
  templateUrl: "./reset-password.component.html",
  styleUrl: "./reset-password.component.scss",
})
export class ResetPasswordComponent {
  email = "";

  constructor(private authService: AuthService, private router: Router) {}

  resetLink() {
    this.authService
      .reset(this.email)
      .then(() => {
        this.router.navigate(['/login']);
      })
      .catch((error) => {
        console.error("Reset Password failed:", error);
      });
  }
}
